import React from "react";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import AddBox from "@material-ui/icons/AddBox";
import IndeterminateCheckBox from "@material-ui/icons/IndeterminateCheckBox";

import withStyles from "@material-ui/core/styles/withStyles";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

class CheckboxTree extends React.Component {
		
		componentDidMount(){
			this.setState({nodes: this.props.nodes})
		}
		clickItem(node){
			this.props.onClickTreeNodeAction(node)
		}
		expandNode(node){
			this.props.setNodeVisibility(node)
		}
		renderTreeNode(node, key){
			const nodeHelper = this.props.treeHelper.find((x) => x.ibTreeNodeId === node.ibTreeNodeId)
			return(
				<div key={key} style={{display: 'flex', paddingLeft: '24px', width: '100%'}}>
					{/* <span>|</span> */}
					<div style={{paddingLeft: '5px'}}>
						<span>
							<Checkbox
								//checked={true}
								onChange={(e) => this.expandNode(node)}
								style={{height: '28px', color: node.selected ? '#00acc1' : 'unset'}}
								checkedIcon={<IndeterminateCheckBox />}
								icon={<AddBox />}
							/>
							<span onClick={()=> this.clickItem(node)} style={{color: node.selected ? '#00acc1' : 'unset', cursor: 'pointer'}}>{node.ib.name + ' ' + node.ib.lastName}</span>
						</span>
						{(nodeHelper.expanded && node.children.length !== 0) && (
								node.children.map((child, ind)=> {
									return(
										this.renderTreeNode(child, ind)
									)
								})		
						)}
					</div>
				</div>
				
			)
		}
    render() {
			const {nodes} = this.props

      return (
				<div style={{paddingTop: '27px'}}>
					{
						nodes.map((node, i) => {
							const nodeHelper = this.props.treeHelper.find((x) => x.ibTreeNodeId === node.ibTreeNodeId)
							return (
								<div key={i}>
									<span>
										<Checkbox
											//checked={true}
											onChange={(e) => this.expandNode(node)}
											style={{height: '28px', color: node.selected ? '#00acc1' : 'unset'}}
											checkedIcon={<IndeterminateCheckBox />}
											icon={<AddBox />}
										/>
										<span onClick={()=> this.clickItem(node)} style={{color: node.selected ? '#00acc1' : 'unset', cursor: 'pointer'}}>{node.ib.name + ' ' + node.ib.lastName}</span>
									</span>
									{(nodeHelper.expanded && node.children.length !== 0) && (
										node.children.map((child, ind)=> {
											return(
												this.renderTreeNode(child, ind)
											)
										})
										
									)}
								</div>
							)
						})
					}
				</div>
      )  
    }
}

export default withStyles({...regularFormsStyle})(CheckboxTree)


// WEBPACK FOOTER //
// ./src/views/ContractDetailsReport/CheckboxTree.jsx